import { isMember } from "../utils"


const memberLinks = [
	{
		gameRule: "feedback-auditorium",
		gameRuleCooldown: 1000*60*60,
		height: "15.7%",
		href: "https://isfcongress.tkeventsregistration.com/ffauditorium",
		isExternal: true,
		label: "Feedback",
		left: "42.3%",
		target: "_blank",
		top: "80.9%",
		width: "7.6%",
	},
	{
		height: "15.7%",
		href: "/roundtables",
		label: "Roundtable Sessions",
		left: "50.3%",
		top: "80.9%",
		width: "7.6%",
	},
]

export default {
	background: "https://assets.swoogo.com/uploads/full/5416778-683f04f00e407.png",
	extras: (
		<>
			<iframe className="auditorium-livestream" src="https://www.youtube.com/embed/H41fuhz_gvw?si=VD_D7wycou1WbWk3&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
		</>
	),
	links: [
		{
			height: "66.1%",
			label: "Livestream",
			left: "21%",
			top: "0.3%",
			width: "58.2%",
		},
		...(isMember ? memberLinks : []),
	],
	name: "auditorium",
}
